import { parseDataTransform } from '@acme/common'
import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useMemo } from 'react'
import {
    Outlet,
    useNavigate,
    useOutletContext,
    useParams,
    useSearchParams,
} from 'react-router-dom'
import { Empresa, empresas, updateEmpresaFormSchema } from 'service/api'
import { toast } from 'sonner'
import { tabs } from '../constants/tabs'

export default function EdicaoEmpresa() {
    const [searchParam] = useSearchParams()
    const navigate = useNavigate()
    const { empresaId } = useParams()
    const { mutateAsync, isLoading } = empresas.mutations.useUpdate({
        invalidateQuery: true,
    })

    const tab = searchParam.get('aba')
    const voltar = searchParam.get('voltar')
    const obrigatorio = searchParam.get('obrigatorio') === 'true'

    const company = useOutletContext<{ data: Empresa[] }>()?.data?.find(
        item => item.id === +empresaId!,
    )!

    function handleSubmit(data: Empresa) {
        return mutateAsync(data, {
            onSuccess: () => {
                toast.success('Empresa atualizada com sucesso!')
            },
            onError: ({ statusCode, message }) => {
                if (statusCode === 422) {
                    ;(message as string[]).forEach(error => toast.error(error))
                } else {
                    toast.error(message)
                }
            },
        })
    }

    const prev = useMemo(() => company, [])

    function handleClose() {
        if (voltar) return navigate(voltar + '?aba=adicionais')
        else if (!prev.documento || !prev.cidadeId)
            return navigate('/cadastros/empresas')
        navigate(-1)
    }

    return (
        <TabbedDialog.Root
            loading={isLoading}
            onClose={obrigatorio ? () => navigate('/dashboard') : handleClose}
            disableEscapeKeyDown={obrigatorio}
            onSubmit={handleSubmit}
            open={hasPermission(['update', 'Empresas'])}
            tabs={tabs}
            defaultTab={tab || undefined}
            schema={updateEmpresaFormSchema}
            defaultValues={{
                ...parseDataTransform(company, {
                    dateFormat: 'toString',
                }),
                uf: company.Cidade?.uf,
                competenciaAtual: company.competenciaAtual,
                proximoFechamentoPonto: company.proximoFechamentoPonto,
                periodoFechamentoPonto: Number(company.periodoFechamentoPonto),
                usarBancoHoras: !!company.periodoFechamentoPonto,
                calculoAutomatico: !!company.hrCalculoAutomatico,
                layoutFolha: company.layoutFolha,
                tipoDescontoDSR: company.tipoDescontoDSR,
                atrasoDescontoDSR: company.atrasoDescontoDSR,
                inicioSemana: company.inicioSemana,
                esconderLinhasOndeNaoTrabalha:
                    company.esconderLinhasOndeNaoTrabalha,
            }}
        >
            <TabbedDialog.Title action="Editar empresa">
                {company?.nomeFantasia}
            </TabbedDialog.Title>
            <TabbedDialog.Content />
            <TabbedDialog.Actions>
                {!obrigatorio && <TabbedDialog.Actions.SecondaryButton />}
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
            <Outlet context={{ data: company }} />
        </TabbedDialog.Root>
    )
}

export function useEditarEmpresaOutletContext() {
    return useOutletContext<{ data: Empresa }>()
}
